import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileEducationRelevanceInput = () => {
  const { setFieldValue } = useFormikContext();

  const educationRelevanceOptions = [
    { label: 'Not required', value: 'NOT_REQUIRED' },
    { label: 'Must be partly job relevant', value: 'MUST_BE_PARTLY_JOB_RELEVANT' },
    { label: 'Must be job relevant', value: 'MUST_BE_JOB_RELEVANT' },
  ];

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.education-relevance"
          defaultMessage="Education relevance"
        >
          {(text) => (
            <label className="field-label" htmlFor="educationRelevance">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="educationRelevance"
              name="educationRelevance"
              component={DropdownComponent}
              options={educationRelevanceOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('educationRelevance', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileEducationRelevanceInput;
